{
  "name": "padtools_ts",
  "version": "0.4.0",
  "bin": {
    "padtools_ts": "dist/cli/cli.js"
  },
  "files": [
    "dist",
    "dist-web",
    "LICENSE",
    "README.md"
  ],
  "scripts": {
    "build": "rimraf dist && tsc",
    "prepublishOnly": "npm run build && npm run build:web",
    "format": "biome format --write .",
    "start": "tsx src/cli/cli.ts",
    "start:api": "tsx src/api/server.ts",
    "start:api:bun": "bun src/api/server.ts",
    "start:mcp": "tsx src/mcp/server.ts",
    "test": "jest",
    "test:bun": "bun test --exclude tests/web",
    "test:jest:bun": "bun x jest",
    "test:web": "playwright test",
    "test:web:headed": "playwright test --headed",
    "test:cov": "jest --coverage",
    "ci": "npm run check && npm run build && npm run build:web && npm run test:cov && npm run test:web && npm run convert:web:commands && npm run convert:web:render_options",
    "update-cli-golden-files": "tsx tests/cli/E2E/updateGoldenFile.ts",
    "update-spd-golden-files": "tsx tests/spd/E2E/updateGoldenFile.ts",
    "update-web-golden-files": "tsx tests/web/updateGoldenFile.ts",
    "lint": "biome lint .",
    "check": "biome check .",
    "check:apply": "biome check --write --unsafe .",
    "start:web": "parcel web/index.html --dist-dir temp/",
    "build:web": "rimraf dist-web && parcel build web/index.html --dist-dir dist-web",
    "build:web:gh-pages": "rimraf gh-pages/ && parcel build web/index.html --dist-dir gh-pages/ --public-url /padtools_ts/ && echo > gh-pages/.nojekyll",
    "convert:web:commands": "tsx web/utility/convert_commands.ts",
    "convert:web:render_options": "tsx web/utility/convert_render_options.ts",
    "deploy": "wrangler deploy",
    "dev:worker": "wrangler dev",
    "prepare": "husky"
  },
  "keywords": [
    "pad",
    "flowchart",
    "diagram",
    "generator",
    "cli",
    "svg",
    "typescript",
    "PAD"
  ],
  "author": "steelpipe",
  "license": "MIT",
  "description": "Simple tool to write PAD.",
  "dependencies": {
    "@hono/mcp": "^0.2.5",
    "@hono/node-server": "^2.0.2",
    "@hono/swagger-ui": "^0.6.1",
    "@hono/zod-openapi": "^1.3.0",
    "@modelcontextprotocol/sdk": "^1.29.0",
    "commander": "^14.0.3",
    "eastasianwidth": "^0.3.0",
    "fastmcp": "^4.0.1",
    "glob": "^13.0.6",
    "hono": "^4.12.18",
    "sanitize-html": "^2.17.4",
    "svgo": "^4.0.1",
    "xml-formatter": "^3.7.0",
    "zod": "^4.3.6"
  },
  "devDependencies": {
    "@biomejs/biome": "^2.4.15",
    "@fullhuman/postcss-purgecss": "^8.0.0",
    "@parcel/packager-ts": "^2.16.4",
    "@parcel/transformer-typescript-types": "^2.16.1",
    "@playwright/test": "^1.56.1",
    "@types/jest": "^30.0.0",
    "@types/node": "^25.6.2",
    "@types/sanitize-html": "^2.16.1",
    "baseline-browser-mapping": "^2.10.29",
    "buffer": "^6.0.3",
    "husky": "^9.1.7",
    "jest": "^30.4.2",
    "parcel": "^2.16.4",
    "postcss": "^8.5.13",
    "rimraf": "^6.1.3",
    "ts-jest": "^29.4.9",
    "tsx": "^4.22.0",
    "typescript": "^6.0.3",
    "wrangler": "^4.92.0"
  },
  "overrides": {
    "test-exclude": "7.0.1",
    "glob": "$glob"
  }
}
